import axios from "axios";
import store from "@/store";
import router from "@/router";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
    namespaced: true,
    state: {
        transaction: {},
        factor: {}
    },
    mutations: {
        setTransaction(state, response) {
            state.transaction = response;
        },
        setFactor(state, factor) {
            state.factor = factor
        }

    },
    actions: {
        createTransaction({commit}, {order, gate, description = null, order_location = null, payment_receipt = null}) {
            const user_id = store.getters["User/getUserId"];

            let form = new FormData()
            form.append('gateway', gate)
            form.append('description', description)
            form.append('order_location', order_location)
            form.append('payment_receipt', payment_receipt)


            let req =
                axios.post(`pay/user/${user_id}/order/${order}/transaction`, form)

            req.then((res) => {

                const data = res.data.data;
                const url = data.payment_url
                if (url === 'FREE') {
                    router.push({name: 'verifyTransaction', params: {slug: data.slug}})
                } else {
                    window.location.href = url;
                }
            })
                .catch((error) => {
                    store.dispatch("ShoppingCart/userOrderUnpaid")
                    console.log(error);
                });

            return req
        },
        verifyTransaction({commit}, slug) {
            axios
                .get(
                    `transaction/verify/order/${slug}`
                )
                .then((res) => {
                    const response = res.data.data;
                    store.commit("ShoppingCart/setUserOrderPaidItems", response);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showTransactionDetail({commit}, order) {
            const user_id = store.getters["User/getUserId"];
            axios
                .post(`/user/${user_id}/order/${order}/transaction`)
                .then((res) => {
                    const response = res.data.data;
                    store.commit("ShoppingCart/setSidebarBasketData", response);
                    commit("setFactor", response);
                    store.commit("ShoppingCart/setUserOrderPaidItems", response.items);
                    store.commit("ShoppingCart/setUserOrderPaidItems", response.items);
                    commit("setTransaction", response.transaction);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        autoPrintShowTransactionDetail({commit}, order) {
            const user_id = store.getters["User/getUserId"];
            return axios.post(`/user/${user_id}/order/${order}/transaction`)
        },
        showOrderDetail({commit}, slug) {
            return axios.get(`user/order/${slug}`)
        },
        getFactor({commit}, orderId) {
            axios.post(`product/products-user/${orderId}`)
                .then((res) => {
                    const factor = res.data.data;
                    commit("setFactor", factor);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        transactionWithoutAuthentication({commit}, {form, mode = 'normal'}) {

            const url = mode === 'normal' ? `order/without/authentication` : 'dashboard/order/create'
            let req = axios.post(url, form)

            req.then(res => {

                if (mode !== 'dashboard') {
                    const data = res.data.data;
                    const url = data.payment_url
                    if (url === 'FREE') {
                        router.push({name: 'verifyTransaction', params: {slug: data.slug}})
                    } else {
                        window.location.href = url;
                    }
                }
                toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
            })
                .catch((error) => {
                    console.log(error);
                });

            return req

        },
        verifyTransactionWithoutState({commit}, slug) {
            return axios.get(`transaction/verify/order/${slug}`)
        },
        removeOrder({commit}, form) {
            return axios.get(`order/remove-order/${form.id}`)
        },
    },
    getters: {
        getTransaction: (state) => state.transaction,
        getFactor: (state) => state.factor
    },
};
